import { motion } from "framer-motion";

const MARKETS = [
  { name: "UAE", time: "24–48 hrs" },
  { name: "Saudi Arabia", time: "3–5 days" },
  { name: "Kuwait", time: "4–6 days" },
  { name: "Qatar", time: "3–5 days" },
  { name: "Bahrain", time: "3–5 days" },
  { name: "Oman", time: "2–4 days" },
  { name: "East Africa", time: "10–14 days" },
  { name: "South Asia", time: "7–12 days" },
];

const STATS = [
  { value: "8+", label: "Regional markets served" },
  { value: "40ft", label: "Monthly container capacity" },
  { value: "48 hrs", label: "Sample dispatch within UAE" },
  { value: "1", label: "Dedicated account manager" },
];

export default function GlobalMarket() {
  return (
    <section id="global" data-testid="global-market-section" className="relative py-20 lg:py-32 px-4 sm:px-8 lg:px-16 overflow-hidden">
      <img
        src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
        alt="Dubai skyline"
        className="absolute inset-0 w-full h-full object-cover opacity-20"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0B0E] via-[#0A0B0E]/80 to-[#0A0B0E]" />

      <div className="relative max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#D4AF37]/80 mb-4">Global Market & GCC Reach</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-snug max-w-3xl">
            From Business Bay <span className="italic text-gold-gradient">to every souk and high street.</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid lg:grid-cols-12 gap-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-4 gap-px bg-[#D4AF37]/15 border border-[#D4AF37]/15"
            data-testid="global-markets-grid"
          >
            {MARKETS.map((m, i) => (
              <div key={m.name} className="bg-[#12141B]/90 backdrop-blur p-5" data-testid={`market-${i + 1}`}>
                <p className="font-display text-lg text-amber-100">{m.name}</p>
                <p className="text-[11px] font-mono tracking-[0.2em] uppercase text-[#D4AF37]/70 mt-1">{m.time}</p>
              </div>
            ))}
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-5 space-y-6"
          >
            {STATS.map((s, i) => (
              <div key={s.label} className="flex items-baseline gap-5 border-b border-[#D4AF37]/15 pb-5" data-testid={`global-stat-${i + 1}`}>
                <span className="font-display text-4xl text-gold-gradient min-w-[110px]">{s.value}</span>
                <span className="text-sm font-light text-slate-300">{s.label}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
